import { Text } from '@bechtel/gds';
import { isEmpty } from 'lodash';
import { FC, PropsWithChildren } from 'react';
import { useLanguage } from '~/components/molecules';
import { MultiLingualTextProps } from './types';

export const MultiLingualText: FC<PropsWithChildren<MultiLingualTextProps>> = ({
  textKey,
  children,
  style,
  ...rest
}) => {
  const { getMultiLingualTextByKey } = useLanguage();
  // Get the key
  const langKey = textKey ? textKey : children ? children.toString().trim() : '';
  const text = getMultiLingualTextByKey(langKey);
  const multiLingualText = isEmpty(text) ? langKey : text;

  return (
    <Text {...rest} style={style ? style : { whiteSpace: 'nowrap' }}>
      {multiLingualText}
    </Text>
  );
};
